import React from "react";
import Api from '../../../services/Api';
import { Icon } from '@fluentui/react/lib/Icon';
import { IPersonaSharedProps, PersonaInitialsColor, Persona, PersonaSize } from '@fluentui/react/lib/Persona';

class QuotaChangeTask extends React.Component {

    constructor(props) {
        super(props);
    }
    
    componentDidMount(): void {
    }

    render() {
        return (
            <div>
            <div style={{display: "flex", flexDirection: "column", alignItems: "center", paddingTop: "10px"}}>      
                <span>Current quota: {this.props.change.currentValue} Gb</span>
                <Icon iconName="Down" style={{ paddingTop: "5px", paddingBottom: "5px" }}/>
                <span>Requested quota: {this.props.change.changeValue} Gb</span>
            </div>
            <div style={createdByStyles}><span style={{fontWeight: "bold"}}>Business Jusctification:</span>{this.props.change.changeQuotaComment}</div>
            </div>
            );
    }
}

const createdByStyles = {
    padding: '8px',
    fontSize: '12px',
    flex: 1
}

export default QuotaChangeTask


// WEBPACK FOOTER //
// ./src/components/ManageCenter/ChangeValues/QuotaChangeTask.js